<style scpoed >

.top-margin {
    margin-left: 5px
}

</style>
<template>

<div class="">

    <div class="">

        <list-template ref="list-template" :hasSearch="true" actionUrl="carShow/carShowInfo/getCsShowChannels.action" :queryParams="searchInfo">

            <template slot="search" scope="scope">

                <el-col :span="4" style="margin-right:20pt;">
                    <el-input type="primary" v-model="searchInfo.keyword"  placeholder="渠道名字搜索"></el-input>
                </el-col>
            </template>
            <template slot="searchButton" scope="scope">
                <!-- <el-button type="danger" style="margin-right:20px;" @click="showAddDialog()">投放到汽车网</el-button> -->
                <el-button type="primary" style="margin-right:20px;" @click="showExclusiveDialog()">创建专属链接</el-button>

                  <el-date-picker
                    v-model="dataTime"
                    type="datetimerange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="导出开始日期"
                    end-placeholder="导出结束日期"
                    :picker-options="pickerOptions2">
                  </el-date-picker>

                <el-button type="warning" style="margin-right:20px;" @click="excelExport()">导出</el-button>
            </template>

            <template slot="item" scope="scope">
                <div>
                      <el-table :data=" scope.datas" border style="width: 100%"     tooltip-effect="dark">
                          <el-table-column label="投放渠道">
                              <template scope="scope">
                                  <span style="margin-left: 10px">{{ scope.row.channelName }} </span>
                              </template>
                          </el-table-column>

                          <el-table-column label="专属链接">
                              <template scope="scope">
                                  <p> {{ scope.row.shortUrl }}</p>
                              </template>
                          </el-table-column>

                          <el-table-column  label="数据概要">
                              <template scope="scope">
                                  <span style="margin-left: 10px">UV {{ scope.row.uv }}(昨日+{{scope.row.uvDay}})</span><br/>
                                  <span style="margin-left: 10px">PV {{ scope.row.pv }}(昨日+{{scope.row.pvDay}})</span><br/>
                                  <span style="margin-left: 10px">线索 {{ scope.row.clueCount }}(昨日+{{scope.row.dayClueCount}})</span><br/>
                              </template>
                          </el-table-column>
                          <el-table-column label="投放状态">
                              <template scope="scope">
                                  <span style="margin-left: 10px">链接:{{scope.row.state | stateFilter}}</span><br/>
                                  <!-- <span style="margin-left: 10px">助力:{{scope.row.assistanceSwitch | stateFilter}}</span><br/>-->
<!--                                  <span style="margin-left: 10px">活动:{{scope.row.activeSwitch==2?'已开启':'已关闭'}}</span>-->
                              </template>
                          </el-table-column>

                          <el-table-column label="创建时间">
                              <template scope="scope">
                                  <p class=" text-nowrap">{{ scope.row.createTime | dateTimeFormat}}</p>
                              </template>
                          </el-table-column>
                          <el-table-column label="操作">
                              <template scope="scope">
                                <el-button type="text"  @click="copyUrl(scope.row.shortUrl)">复制链接</el-button>
                                <el-button v-if="scope.row.state==1" type="text"  @click="updateChannelSwitch(scope.row.id,1)">关闭链接</el-button>
                                <el-button v-else="scope.row.state==2" type="text"  @click="updateChannelSwitch(scope.row.id,1)">开启链接</el-button>
                                <!-- <el-button v-if="scope.row.assistanceSwitch==1" type="text"  @click="updateChannelSwitch(scope.row.id,2)">关闭助力</el-button>
                                <el-button  v-else="scope.row.assistanceSwitch==2" type="text"  @click="updateChannelSwitch(scope.row.id,2)">开启助力</el-button> -->
<!--                                <el-button v-if="scope.row.activeSwitch==2" type="text"  @click="updateChannelSwitch(scope.row.id,3)">关闭活动</el-button>-->
<!--                                  <el-button v-else="scope.row.activeSwitch==1" type="text"  @click="updateChannelSwitch(scope.row.id,3)">开启活动</el-button>-->
                              </template>
                          </el-table-column>

                      </el-table>
                </div>
            </template>
        </list-template>

        <el-dialog size="tiny" title="投放到汽车网" :visible.sync="showaddForm" width="30%" >
          <el-row>
              <el-form :model="addChannelForm"  :rules="rules" ref="addChannelForm"  label-width="150px">

                  <el-col :span="20" class="basic-margin">

                      <el-form-item label="" label-position="left" prop="provinceName">
                        <el-select v-model="addChannelForm.provinceName" clearable filterable placeholder="请选择省份" @change="getcdChannel()">
                          <el-option
                            v-for="item in provinces"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            <span style="float: left">{{ item.label }}</span>
     <span style="float: right; color: #8492a6; font-size: 13px">已投放{{item.addnum}},可投放{{item.num-item.addnum}}</span>
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="" label-position="left" prop="channelIds">
                        <el-select v-model="addChannelForm.channelIds" clearable filterable multiple  placeholder="请选择渠道（选择全选省下的所有渠道）">
                          <el-option
                            v-for="item in channels"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">

                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item class="basic-margin">
                          <el-button type="primary"  @click="submitForm('addChannelForm')">保存</el-button>
                          <el-button @click="back('addChannelForm')">取消</el-button>
                      </el-form-item>
                  </el-col>
              </el-form>
          </el-row>
        </el-dialog>

        <el-dialog size="tiny" title="设置专属链接" :visible.sync="showExclusiveForm" width="30%" >
          <el-row>
              <el-form :model="addExclusiveForm"  :rules="exclusiveRules" ref="addExclusiveForm"  label-width="150px">

                  <el-col :span="20" class="basic-margin">

                    <el-form-item label="" label-position="left" prop="channelName">
                        <el-input v-model="addExclusiveForm.channelName" placeholder="请输入渠道名称（同名渠道不能重复创建）">
                        </el-input>
                        <span style="color:red">用于非汽车网渠道 生成专属链接</span>
                    </el-form-item>

                      <el-form-item class="basic-margin">
                          <el-button type="primary"  @click="submitExclusiveForm('addExclusiveForm')">保存</el-button>
                          <el-button @click="back('addExclusiveForm')">取消</el-button>
                      </el-form-item>
                  </el-col>
              </el-form>
          </el-row>
        </el-dialog>

    </div>

</div>

</template>

<script>

import Config from '@/framework/configs/Config'
import BasicPager from '../../../mixins/BasicPager'
import ListTemplate from '../../../components/ListTemplate'
import CsChannelModel from '@/framework/models/csChannelModel'
export default {
  name: 'channel-manager',
  extends: BasicPager,

  data: function () {
    var checkInputChannelName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('渠道名称1111不能为空'))
      }
      let params = {
        channelName: value
      }

      let listener = {
        success: function (dataInfo) {
          if (dataInfo.datas.isExists) {
            console.log('1')
            callback(new Error('渠道名字已存在'))
          } else {
            console.log('2')
            callback()
          }
        }
      }
      CsChannelModel.checkChannelName(this, params, listener)
    }
    return {
      pickerOptions2: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      dataTime: [],
      baseImageUrl: Config.imageUrl,
      baseUrl: Config.baseUrl,
      searchInfo: {
        carShowInfoId: null,
        keyword: null
      },
      showaddForm: false,
      showExclusiveForm: false,
      provinces: null,
      channels: null,
      addChannelForm: {
        provinceName: null,
        channelIds: [],
        carShowInfoId: null
      },
      addExclusiveForm: {
        carShowInfoId: null,
        channelName: null
      },
      rules: {
        channelIds: [{
          required: true,
          message: '渠道不能为空',
          trigger: 'blur'
        }]

      },

      exclusiveRules: {
        channelName: [
          { validator: checkInputChannelName, trigger: 'blur' }
        ]
      }

    }
  },

  components: {
    ListTemplate,
    CsChannelModel
  },
  created: function () {
    let carShowInfoId = this.$route.params.carShowInfoId
    this.searchInfo.carShowInfoId = carShowInfoId
    this.addChannelForm.carShowInfoId = carShowInfoId
    this.addExclusiveForm.carShowInfoId = carShowInfoId
  },
  activated: function () {
    let carShowInfoId = this.$route.params.carShowInfoId
    this.searchInfo.carShowInfoId = carShowInfoId
    this.addChannelForm.carShowInfoId = carShowInfoId
    this.addExclusiveForm.carShowInfoId = carShowInfoId

    this.$refs['list-template'].search()
  },
  filters: {
    stateFilter: function (value) {
      let str = ''
      switch (value) {
        case 1:
          str = '已开启'
          break
        case 2:
          str = '已关闭'
          break
        default:
      }
      return str
    }
  },
  methods: {
    excelExport: function () {
      let userInfo = this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      let url = Config.baseUrl + '/carShow/carShowInfo/exportChannelDataExcel.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath +
          '&carShowInfoId=' + this.searchInfo.carShowInfoId

      if (this.dataTime && this.dataTime[0]) {
        url += '&startTime=' + this.dataTime[0].getTime() + '&endTime=' + this.dataTime[1].getTime()
      }
      window.open(url)
    },
    copyUrl: function (url) {
      let _this = this
      const h = _this.$createElement
      let input = h('input', {
        style: 'color: teal',
        class: 'el-input__inner',
        attrs: {
          value: url
        }
      }, 'VNode')

      _this.$msgbox({
        title: '复制商家主页链接推广',
        message: h('p', null, [
          input
        ]),
        showCancelButton: true,
        confirmButtonText: '复制',
        cancelButtonText: '取消'
      }).then(action => {
        if (action === 'confirm') {
          input.elm.select()
          document.execCommand('Copy') // 执行浏览器复制命令
          _this.$message({
            message: '复制成功！',
            type: 'success'
          })
          done()
        } else {
          done()
        }
      })
    },
    showExclusiveDialog: function () {
      this.showExclusiveForm = true
    },
    back: function (formName) {
      this.$refs[formName].resetFields()
      this.showaddForm = false
      this.showExclusiveForm = false
    },
    addCsSHowChannel: function () {
      let _this = this
      let params = {
        carShowInfoId: _this.addChannelForm.carShowInfoId,
        channelIds: _this.addChannelForm.channelIds.join(',')

      }

      let listener = {
        success: function (dataInfo) {
          _this.dialogVisible = false
          _this.$message({
            type: 'success',
            message: dataInfo.errMsg
          })
          _this.showaddForm = false

          _this.$refs['list-template'].search()
        }
      }
      CsChannelModel.addCsSHowChannel(this, params, listener)
    },
    addExclusiveChannel: function () {
      let _this = this
      let params = {
        carShowInfoId: _this.addExclusiveForm.carShowInfoId,
        channelName: _this.addExclusiveForm.channelName

      }
      let listener = {
        success: function (dataInfo) {
          _this.dialogVisible = false
          _this.$message({
            type: 'success',
            message: dataInfo.errMsg
          })
          _this.showExclusiveForm = false
          _this.$refs['list-template'].search()
        }
      }
      CsChannelModel.addExclusiveCsSHowChannel(this, params, listener)
    },
    submitExclusiveForm: function (formName) {
      console.log(this.addExclusiveForm.channelName)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addExclusiveChannel()
          this.$refs[formName].resetFields()
        }
      })
    },
    submitForm: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addCsSHowChannel()
          this.$refs[formName].resetFields()
        }
      })
    },
    updateChannelSwitch: function (id, type) {
      let _this = this
      let params = {
        id: id,
        type: type
      }
      let listener = {
        success: function (dataInfo) {
          _this.dialogVisible = false
          _this.$message({
            type: 'success',
            message: dataInfo.errMsg
          })
          _this.$refs['list-template'].search()
        }
      }
      CsChannelModel.updateChannelSwitch(this, params, listener)
    }

  }
}

</script>
